import React, { FC } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../constants/aampeTheme';

interface PreviewErrorProps {
    message: string | null;
}

const PreviewError: FC<React.PropsWithChildren<PreviewErrorProps>> = ({
    message,
}) => {
    return (
        <Container>
            <ErrorHeader>Unable to generate previews</ErrorHeader>
            {message && <ErrorBody>{message}</ErrorBody>}
        </Container>
    );
};

export default PreviewError;

const Container = styled.div({
    margin: aampeTheme.spacing(1),
    padding: aampeTheme.spacing(4),
    width: '80%',
    borderRadius: aampeTheme.borderRadius.default,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: aampeTheme.colors.white,
    gap: aampeTheme.spacing(2),
});

const ErrorHeader = styled.div({
    fontSize: aampeTheme.size.font.default,
    textAlign: 'center',
    fontWeight: aampeTheme.weights.medium,
    color: aampeTheme.colors.error600,
});

const ErrorBody = styled.div({
    fontSize: aampeTheme.size.font.default,
    color: aampeTheme.colors.secondaryGray,
    textAlign: 'center',
});
